import React, { useMemo } from 'react'

import LinkedResourceActions from 'components/integrations/LinkedResourceActions'
import NavigatableIntegrationWidgetCard from 'components/integrations/NavigatableIntegrationWidgetCard'
import { Label, Loader } from 'shared/ui'
import EmptyMessage from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/shared/EmptyMessage'
import { isEmpty } from 'util/arrays'

import StripeSubscriptionRow from './StripeSubscriptionRow'
import StripeChargeRow from './StripeChargeRow'

export default function StripeIndex({
  className,
  data,
  doNavigatableSetState,
  isLoading,
}) {
  const {
    customerId,
    charges: { data: chargesData = [] } = {},
    subscriptions: { data: subscriptionData = [] } = {},
  } =
    data || {}

  const actions = useMemo(
    () => [
      {
        blankTarget: true,
        text: ['View on Stripe'],
        url: `https://dashboard.stripe.com/customers/${customerId}`,
      },
    ],
    [customerId]
  )
  if (isLoading) return <Loader />
  if (!customerId)
    return <EmptyMessage>There is no customer information</EmptyMessage>
  return (
    <div className={className}>
      <Label>Subscriptions</Label>
      <NavigatableIntegrationWidgetCard.List>
        {isEmpty(subscriptionData) && (
          <EmptyMessage>This customer has no subscriptions</EmptyMessage>
        )}
        {!isEmpty(subscriptionData) &&
          subscriptionData.map(subscription => {
            return (
              <StripeSubscriptionRow
                doNavigatableSetState={doNavigatableSetState}
                subscription={subscription}
              />
            )
          })}
      </NavigatableIntegrationWidgetCard.List>
      <Label>Recent charges</Label>
      <NavigatableIntegrationWidgetCard.List>
        {isEmpty(chargesData) && (
          <EmptyMessage>No charges data to show here</EmptyMessage>
        )}
        {!isEmpty(chargesData) &&
          chargesData.map(charge => {
            return (
              <StripeChargeRow
                doNavigatableSetState={doNavigatableSetState}
                charge={charge}
              />
            )
          })}
      </NavigatableIntegrationWidgetCard.List>
      <LinkedResourceActions actions={actions} />
    </div>
  )
}
